export default __webpack_public_path__ + "static/media/GoodMannerWithYourParents_02.bdaa8844.png";